module.exports = __webpack_public_path__ + "static/media/img_2_0.f9e9fda2.png";